import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  CardMedia,
  CardActionArea,
  Typography,
} from '@material-ui/core';
import { useStyles, Button } from './styles';
import linkCards from '../../../constants/linkCards';

const UnitCard = (props) => {
  const { unit, onSearchUnity } = props;
  const classes = useStyles();

  const chooseUrl = (unitId) => {
    const imageUrl = linkCards
      .filter((link) => link.id === Number(unitId))
      .pop();
    return imageUrl.link;
  };
  const url = chooseUrl(unit.id);

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={onSearchUnity}>
        <CardMedia
          component="img"
          height="140"
          image={url || 'https://picsum.photos/400/300'}
        />
        <CardContent>
          <Typography className={classes.title}>{unit.unidad}</Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button width="fullWidth" onClick={onSearchUnity}>
          Buscar Insights
        </Button>
      </CardActions>
    </Card>
  );
};

export default UnitCard;
